import StartChallengeFormHERO10X from './StartChallengeFormHERO10X';

export default StartChallengeFormHERO10X;
